export default __webpack_public_path__ + "static/bw-ammo-c5e247c7023616df84c4f10f0165ce83.png";